module.exports = __webpack_public_path__ + "img/add-bg-1.377a63e0.png";